import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import Icon from '../icons/Icon';
import iconsList from '../icons/iconsList';
import FinalEntryPopup from '../../sections/FinalSection/FinalButton/FinalEntryPopup/FinalEntryPopup';
import classes from './FinalDayButton.module.css';

const FinalDayButton = ({ text, onClick, className, showPopupFinalEntryPopup }) => {

  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);

  const handleClick = () => {
    if (showPopupFinalEntryPopup)
      setShowPopup(true);
    else
      navigate('/finalPage', { state: { navigation: 'InitiatedTransferWithUserInteraction' } });
  };

  return (
    <div className={className || classes.wrapper}>
      <button type="button" className={classes.finalDay} onClick={handleClick}>
        <div className={classes.finalDayInner}>
          <Icon name={iconsList.finalVictoryCup} size="40.878px" />
          <span className={classes.finalDayText}>{text}</span>
        </div>
      </button>
      {showPopup && <FinalEntryPopup onClose={() => setShowPopup(false)} />}
    </div>
  );
};

export default FinalDayButton;
